import BreadcrumbTwo from "../../../components/Breadcrumbs/BreadcrumbTwo";
import BrandTable from "../../../components/Catalog/brand/BrandTable";
import DefaultLayout from "../../../layout/DefaultLayout";


/**
 * 🏷️ Página de Marcas
 */
const BrandPage = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
       <BrandTable />
    </DefaultLayout>
  );
};

export default BrandPage;